// Generated by scripts/align_sonatas.ts variations. Do not edit by hand.
import type { SonataFile } from '../sonatas/types';
import s0 from './json/k179.json';
import s1 from './json/k265.json';
import s2 from './json/k353.json';
import s3 from './json/k354.json';
import s4 from './json/k398.json';
import s5 from './json/k455.json';
import s6 from './json/k501.json';
import s7 from './json/k573.json';
import s8 from './json/k613.json';
import s9 from './json/op34.json';
import s10 from './json/op76.json';
import s11 from './json/woo63.json';
import s12 from './json/woo64.json';
import s13 from './json/woo65.json';
import s14 from './json/woo66.json';
import s15 from './json/woo68.json';
import s16 from './json/woo69.json';
import s17 from './json/woo70.json';
import s18 from './json/woo71.json';
import s19 from './json/woo72.json';
import s20 from './json/woo73.json';
import s21 from './json/woo75.json';
import s22 from './json/woo77.json';
import s23 from './json/woo78.json';
import s24 from './json/woo80.json';

/** Theme-and-variations sets that passed the alignment gate: Mozart, then Beethoven (compact; decode with ../chorales/codec.ts). */
export const VARIATION_FILES = [s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15, s16, s17, s18, s19, s20, s21, s22, s23, s24] as unknown as SonataFile[];
